// imports
import { FORM_CONTROL, LOGIN_FORM, SIGN_UP_FORM, SIGN_UP_OTP_FORM, FORM_SUBMIT_ERROR_DEFAULT_MESSAGE, APP_DATA, FORM_SUBMIT_STATUS, DOMAIN_SHOPTYPE, COSELL_PUBLISH_FORM, FORM_SUBMIT_BUTTON_ID, FORGOT_PASSWORD_FORM, RESET_PASSWORD_FORM, FORM_SUBMIT_SUCCESS_DEFAULT_MESSAGE } from "./constants";
import { disableFormSubmitButtonAndShowLoader, enableFormSubmitButtonAndShowLoader, hideFormSubmitError, showFormSubmitError, removeButtonLoader, disableButtonById, showFormSubmitSuccess } from "./utils";
import { get, post } from "./api-services";

// constants
const LOGIN_ENDPOINT = "/cosellers/quick-login";
const SIGN_UP_ENDPOINT = "/register?verificationMethod=OTP";
const VALIDATE_EMAIL_OTP_ENDPOINT = "/validate-email-otp";
const QUICK_SIGN_UP_ENDPOINT = "/cosellers";
const RESEND_VERIFICATION_EMAIL_ENDPOINT = "/resend-verification-email?verificationMethod=OTP";
const QUICK_LOGIN_ENDPOINT = "/cosellers/quick-social-login";
const ADDRESS_DETAILS_ENDPOINT = "/address";
const PUBLISH_SLUG_ENDPOINT = "/track/publish-slug";
const FORGOT_PASSWORD_ENDPOINT = "/forgot-password";
const RESET_PASSWORD_OTP_ENDPOINT = "/reset-password-otp";
const PUBLISH_PRODUCT_ENDPOINT = "/publish-product";

export const loginAndGetToken = async () => {
    const reqBody = {
        email: document.getElementById(FORM_CONTROL[LOGIN_FORM].email.id).value,
        password: document.getElementById(FORM_CONTROL[LOGIN_FORM].password.id).value,
    };

    disableFormSubmitButtonAndShowLoader(LOGIN_FORM);
    const res = await post(
        LOGIN_ENDPOINT,
        reqBody
    );
    enableFormSubmitButtonAndShowLoader(LOGIN_FORM);

    if (res.ok) {
        window[APP_DATA].userToken = res.data.token;
        hideFormSubmitError(LOGIN_FORM);
        return res.data.token;
    } else {
        showFormSubmitError(LOGIN_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[LOGIN_FORM]);
        return null;
    }
};

export const signUpAndGetStatus = async () => {
    const reqBody = {
        name: document.querySelector(`#${FORM_CONTROL[SIGN_UP_FORM].firstName.id}`).value + " " + document.querySelector(`#${FORM_CONTROL[SIGN_UP_FORM].lastName.id}`).value,
        email: document.querySelector(`#${FORM_CONTROL[SIGN_UP_FORM].email.id}`).value,
        password: document.querySelector(`#${FORM_CONTROL[SIGN_UP_FORM].password.id}`).value,
    };

    let url = SIGN_UP_ENDPOINT;

    if (window[APP_DATA].rid) {
        url = url + `&rid=${window[APP_DATA].rid}`;
    }
    if (window[APP_DATA].tid) {
        url = url + `&tid=${window[APP_DATA].tid}`;
    }

    disableFormSubmitButtonAndShowLoader(SIGN_UP_FORM);
    const res = await post(
        url,
        reqBody
    );
    enableFormSubmitButtonAndShowLoader(SIGN_UP_FORM);

    if (res.ok) {
        hideFormSubmitError(SIGN_UP_FORM);
        window[APP_DATA].email = reqBody.email;
        window[APP_DATA].signUpId = res.data.data.id || null;
        return FORM_SUBMIT_STATUS.success;
    } else {
        showFormSubmitError(SIGN_UP_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[SIGN_UP_FORM]);
        window[APP_DATA].email = null;
        window[APP_DATA].signUpId = null;
        return FORM_SUBMIT_STATUS.failed;
    }
};

export const resendVerificationOtp = async () => {
    const reqBody = { email: window[APP_DATA].email };

    const res = await post(
        RESEND_VERIFICATION_EMAIL_ENDPOINT,
        reqBody
    );

    if (res.ok) {
        hideFormSubmitError(SIGN_UP_OTP_FORM);
    } else {
        showFormSubmitError(SIGN_UP_OTP_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE.signUpOtpFormResendEmailOtp);
    }
};

export const submitOtpAndGetToken = async () => {
    try {
        const reqBody = {
            id: window[APP_DATA].signUpId,
            verificationCode: document.getElementById(FORM_CONTROL[SIGN_UP_OTP_FORM].emailOtp.id).value,
        };

        disableFormSubmitButtonAndShowLoader(SIGN_UP_OTP_FORM);
        const res = await post(
            VALIDATE_EMAIL_OTP_ENDPOINT,
            reqBody
        );

        if (res.ok) {
            const headers = { authorization: res.data.token };

            const quickSignUpRes = await post(
                QUICK_SIGN_UP_ENDPOINT,
                {},
                headers
            );
            enableFormSubmitButtonAndShowLoader(SIGN_UP_OTP_FORM);

            if (quickSignUpRes.ok) {
                return quickSignUpRes.data.token;
            } else {
                showFormSubmitError(SIGN_UP_OTP_FORM, quickSignUpRes.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[SIGN_UP_OTP_FORM]);
                return null;
            }
        } else {
            enableFormSubmitButtonAndShowLoader(SIGN_UP_OTP_FORM);
            showFormSubmitError(SIGN_UP_OTP_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[SIGN_UP_OTP_FORM]);
            return null;
        }
    } catch (err) {
        console.error(err);
    }
};

export const socialLoginAndGetToken = async (token, provider, form) => {
    const reqBody = {
        token,
        provider,
        domain: window[APP_DATA].domain || DOMAIN_SHOPTYPE
    };

    let url = QUICK_LOGIN_ENDPOINT;

    if (window[APP_DATA].rid && window[APP_DATA].tid) {
        url = url + `?rid=${window[APP_DATA].rid}&tid=${window[APP_DATA].tid}`;
    } else if (window[APP_DATA].rid) {
        url = url + `?rid=${window[APP_DATA].rid}`;
    } else if (window[APP_DATA].tid) {
        url = url + `?tid=${window[APP_DATA].tid}`;
    }

    disableFormSubmitButtonAndShowLoader(form);
    const res = await post(
        url,
        reqBody
    );
    enableFormSubmitButtonAndShowLoader(form);

    if (res.ok) {
        window[APP_DATA].userToken = res.data.Token;
        hideFormSubmitError(form);
        return res.data.Token;
    } else {
        showFormSubmitError(form, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[form]);
        return null;
    }
};

export const getLocationDetails = async (coords) => {
    const reqParams = `geoLat=${coords.lat}&geoLng=${coords.long}`;

    const res = await get(
        `${ADDRESS_DETAILS_ENDPOINT}?${reqParams}`
    );

    if (res.ok) {
        return res.data;
    } else {
        return null;
    }
};

export const getPublishSlug = async (token, productId) => {
    try {
        const headers = { authorization: token };
        let url = PUBLISH_SLUG_ENDPOINT;

        url += `?productId=${productId}`;

        const res = await get(
            url,
            headers
        );

        if (res.ok) {
            return res.data;
        } else {
            removeButtonLoader([FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyShareLink, FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyEmbedCode]);
            showFormSubmitError(COSELL_PUBLISH_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[COSELL_PUBLISH_FORM]);
            return null;
        }
    } catch (err) {
        console.error(err);
    }
};

export const forgotPasswordFormSubmitAndGetStatus = async () => {
    try {
        const reqBody = {
            email: document.getElementById(FORM_CONTROL[FORGOT_PASSWORD_FORM].email.id).value,
            method: "OTP",
        };

        disableFormSubmitButtonAndShowLoader(FORGOT_PASSWORD_FORM);
        const res = await post(
            FORGOT_PASSWORD_ENDPOINT,
            reqBody
        );
        enableFormSubmitButtonAndShowLoader(FORGOT_PASSWORD_FORM);

        if (res.ok) {
            hideFormSubmitError(FORGOT_PASSWORD_FORM);
            window[APP_DATA].forgotPasswordEmail = reqBody.email;
            return FORM_SUBMIT_STATUS.success;
        } else {
            showFormSubmitError(FORGOT_PASSWORD_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[FORGOT_PASSWORD_FORM]);
            return FORM_SUBMIT_STATUS.failed;
        }
    } catch (err) {
        console.error(err);
    }
};

export const resetPasswordFormSubmitAndGetStatus = async () => {
    try {
        const reqBody = {
            email: window[APP_DATA].forgotPasswordEmail,
            password: document.getElementById(FORM_CONTROL[RESET_PASSWORD_FORM].password.id).value,
            otp: document.getElementById(FORM_CONTROL[RESET_PASSWORD_FORM].emailOtp.id).value
        };

        disableFormSubmitButtonAndShowLoader(RESET_PASSWORD_FORM);
        const res = await post(
            RESET_PASSWORD_OTP_ENDPOINT,
            reqBody
        );
        enableFormSubmitButtonAndShowLoader(RESET_PASSWORD_FORM);

        if (res.ok) {
            showFormSubmitSuccess(RESET_PASSWORD_FORM, res.data.message || FORM_SUBMIT_SUCCESS_DEFAULT_MESSAGE[RESET_PASSWORD_FORM]);
            window[APP_DATA].forgotPasswordEmail = null;
            return FORM_SUBMIT_STATUS.success;
        } else {
            showFormSubmitError(RESET_PASSWORD_FORM, res.data.message || FORM_SUBMIT_ERROR_DEFAULT_MESSAGE[RESET_PASSWORD_FORM]);
            return FORM_SUBMIT_STATUS.failed;
        }
    } catch (err) {
        console.error(err);
    }
};

export const publishProduct = async (reqBody) => {
    const headers = { authorization: window[APP_DATA].cosell.token || window[APP_DATA].userToken };
    try {
        await post(
            PUBLISH_PRODUCT_ENDPOINT,
            reqBody,
            headers
        );
    } catch (err) {
        console.error(err);
    }
};